<div
  class="alert alert-success"
  [@openClose]="hideAlert ? 'closed' : 'open'"
  role="alert"
>
  <span class="close" (click)="hideAlertHandler()">x</span>
  <p>{{ description }}</p>
  <hr />
  <a class="cpp-button" [href]="url" target="_blank">
    {{ buttonLabel }}</a
  >
  <span class="alert__checkbox-container">
    <input id="dnt-show" type="checkbox" (change)="dontShowMoreHandler()" />
    <label for="dnt-show">{{ dontShowMoreLabel }}</label>
  </span>
</div>
